// extracted by css-extract-rspack-plugin
export default {"pill":"Nty83","interactive":"X3JXS","dropdown":"Q21m2","dimensionList":"IA59B"};